module.exports = __webpack_public_path__ + "static/media/Create-Table.7e909008.png";